import { render, staticRenderFns } from "./reason-panel.vue?vue&type=template&id=3989faea"
import script from "./reason-panel.vue?vue&type=script&lang=js"
export * from "./reason-panel.vue?vue&type=script&lang=js"
import style0 from "./reason-panel.vue?vue&type=style&index=0&id=3989faea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports